const isTimeOver = (countdown?: number) => countdown === undefined || countdown < 1;

const calcTimeDifference = (timestamp: number, date?: string) => {
  if (!date) {
    return 0;
  }

  return new Date(date).getTime() - timestamp;
};

export {calcTimeDifference, isTimeOver};
